<template>
  <div class="commands-container">
    <v-flex class="space1"></v-flex>
    <sequential-entrance fromBottom delay="500">
      <div class="command-gallery">
        <v-card
          v-for="(item, index) in items"
          :key="index"
          class="command-card"
          @click="executeCommand(item.title)"
        >
          <!-- <v-card-title class="command-card-title">{{ item.title }}</v-card-title> -->
          <v-card-subtitle class="command-card-title">Command: {{ item.explanation }}</v-card-subtitle>
        </v-card>
      </div>
    </sequential-entrance>
  </div>
</template>

<script>
export default {
  name: "CommandsAssistant",
  data() {
    return {
      items: [
        { title: "Google Search", explanation: "Google (News about Tesla)" },
        { title: "Research a Topic", explanation: "Research (Quantum Mechanics)" },
        { title: "Asks the AI a Question", explanation: "Computer (what is AI?)" },
        { title: "Activates AI Image Generator", explanation: "Generate Image" },
        { title: "Start Daily Briefing", explanation: "Daily Briefing" },
        { title: "Navigate to Dashboard", explanation: "Navigate to Dashboard" },
        { title: "Navigate to Welcome", explanation: "Navigate to Welcome" },
        { title: "Navigate to Data Room", explanation: "Navigate to Data Room" },
        { title: "Navigate to Detective", explanation: "Navigate to Detective" },
        { title: "Navigate to Creator", explanation: "Navigate to Creator" },
        { title: "Navigate to Intel", explanation: "Navigate to Intel" },
        { title: "Navigate to Program", explanation: "Navigate to Program" },
        { title: "Navigate to Designer", explanation: "Navigate to Designer" },
        { title: "Navigate to Video Player", explanation: "Navigate to Video Player" },
        { title: "Navigate to Tasks", explanation: "Navigate to Tasks" },
        { title: "Navigate to Generative AI", explanation: "Navigate to Generative AI" },
        { title: "Navigate to Concierge", explanation: "Navigate to Concierge" },
        { title: "Navigate to Interface", explanation: "Navigate to Interface" },
        { title: "Logout", explanation: "Log out" },
        { title: "Enable Dark Mode", explanation: "dark mode" },
        { title: "Disable Dark Mode", explanation: "light mode" },
        { title: "Close App", explanation: "Close" },
        { title: "Stop Action", explanation: "Stop" },
        { title: "Shows the available Commands", explanation: "Show Commands" },
        { title: "Starts the training AI", explanation: "Start Training" },
      ],
    };
  },
  methods: {
    executeCommand(command) {
      const msg = command.toLowerCase();

      // Navigation Commands
      if (msg.indexOf("navigate") !== -1) {
        setTimeout(() => {
          if (msg.indexOf("dashboard") !== -1) {
            this.$router.push({ name: "Dashboard" });
            this.readOutLoud("Here is your Dashboard");
            window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
          } else if (msg.indexOf("notes") !== -1) {
            this.$router.push({ name: "Notes" });
            this.readOutLoud("Navigating to your Notes");
            window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
          }
          // ... Additional Navigation Commands
        }, 500);
      }

      // Logout Command
      else if (msg.indexOf("logout") !== -1 || msg.indexOf("log out") !== -1) {
        this.$router.push({ name: "Login" });
        this.readOutLoud("Logging out");
        return;
      }

      // Dark Mode Command
      else if (msg.indexOf("dark mode") !== -1 || msg.indexOf("dark") !== -1) {
        // new Audio(startAudioDark).play();
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        this.readOutLoud("Switching to dark mode");
        window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        return;
      }

      // Undarken (Light Mode) Command
      else if (msg.indexOf("undarken") !== -1 || msg.indexOf("light mode") !== -1) {
        // new Audio(startAudioLight).play();
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        this.readOutLoud("Switching back to light mode");
        window.scrollTo({ top: 0, left: document.body.scrollHeight, behavior: "smooth" });
        return;
      }

      // Next Slide Command
      else if (msg.indexOf("next") !== -1) {
        this.$refs.slick.next();
        this.readOutLoud("Moving to the next slide");
        return;
      }

      // Previous Slide Command
      else if (msg.indexOf("previous") !== -1) {
        this.$refs.slick.prev();
        this.readOutLoud("Moving to the previous slide");
        return;
      }

      // Google Search Command
      else if (msg.indexOf("google") !== -1) {
        this.readOutLoud('Initiating Google Search for ' + msg.replace('google', '') + '');
        setTimeout(() => {
          // new Audio(startAudioChange).play();
          window.open('https://www.google.com/search?q=' + msg.replace('google', ''), '_blank');
        }, 2000);
        return;
      }

      // Close App Command
      else if (msg.indexOf("close") !== -1) {
        this.readOutLoud("Closing the app");
        window.close();
        return;
      }

      // Stop Action Command
      else if (msg.indexOf("stop") !== -1) {
        this.readOutLoud("Stopping current task");
        // You can implement task cancellation logic here
        return;
      }

      // Default to handling other commands
    },

    readOutLoud(text) {
      const speech = new SpeechSynthesisUtterance(text);
      window.speechSynthesis.speak(speech);
    },
  },
};
</script>

<style scoped>
.commands-container {
  text-align: center;
  padding: 160px;
  background-color: rgba(3, 3, 11, 0.7); /* Dark blue, transparent background */
}

.command-gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: -120px;
}

.command-card {
  width: 300px;
  padding: 20px;
  background: rgba(10, 10, 41, 0.4); /* Transparent dark blue */
  color: #ffffff;
  border: 2px solid rgba(0, 255, 204, 0.8); /* Neon-like border for futuristic effect */
  box-shadow: 0 0 5px rgba(0, 255, 204, 0.8); /* Glow effect */
  border-radius: 15px;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  backdrop-filter: blur(5px); /* Glassmorphism effect */
  text-align: center; /* Center the title and explanation */
}

.command-card:hover {
  transform: scale(1.1); /* Smooth scaling on hover */
  box-shadow: 0 0 5px rgba(22, 14, 44, 0.5); /* Stronger glow on hover */
}

.command-card::before {
  content: '';
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  border-radius: 15px;
  background: linear-gradient(45deg, rgba(0, 255, 204, 0.1), rgba(0, 128, 255, 0.15));
  filter: blur(8px);
  opacity: 0.7;
  transition: opacity 0.5s ease-in-out;
  z-index: -1;
}

.command-card:hover::before {
  opacity: .5; /* Glow effect intensifies on hover */
}


.command-card-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  padding-block: 10px;
}

.command-card-subtitle {
  font-size: 28px;
  opacity: 1;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 15px rgba(0, 255, 204, 0.8);
  }
  50% {
    box-shadow: 0 0 30px rgba(0, 255, 204, 1);
  }
  100% {
    box-shadow: 0 0 15px rgba(0, 255, 204, 0.8);
  }
}

.space1 {
  margin-bottom: 50px;
}
</style>
